const CONST = {
    'SET_SELECTED': 'TOOLS/SET_SELECTED',
    'CLEAR_SELECTED': 'TOOLS/CLEAR_SELECTED',
}

export default CONST;

